import decodeJwt from 'jwt-decode';

export const tokenIsExpired = _ => {
    const storedJwt = localStorage.getItem("jwt")
    if (!storedJwt) return true
    const decodedJwt = decodeJwt(storedJwt)
    return decodedJwt.exp <= (Date.now() / 1000)
}